import { Module } from "wrapper6";
import Glide from '@glidejs/glide'
import SimpleLightbox from 'simple-lightbox';
import { ArrowControls } from '../utils/_glide-plugins';

export default class GallerySlider extends Module {
  ready(app) {
    const GALLERY_SLIDER_WRAP = document.querySelector('.mtt-gallery-slider');
    this.sliding = false;
    this.lightBox;

    if (GALLERY_SLIDER_WRAP) {
      const GLIDE_OPTIONS = {
        type: 'carousel',
        gap: 32,
        peek: {
          before: 0,
          after: 400
        },
        arrowClasses: {
          next: 'arrow-right',
          back: 'arrow-left'
        },
        breakpoints: {
          1000: {
            gap: 24,
            peek: {
              before: 0,
              after: 200
            }
          },
          580: {
            gap: 16,
            peek: {
              before: 0,
              after: 0
            }
          },
        }
      }

      const SLIDER = new Glide('.mtt-gallery-slider__slider', GLIDE_OPTIONS);

      SLIDER.on('run', () => {
        this.sliding = true;
      });

      SLIDER.on('run.after', () => {
        this.sliding = false;
      });

      SLIDER.mount({ArrowControls});
      this.lightBox = new SimpleLightbox({ elements: '.mtt-gallery-slider__slider a' });
      this.preventGalleryWhileSliding();
    }
  }

  preventGalleryWhileSliding() {
    const GALLERY_IMAGES = document.querySelectorAll('.mtt-gallery-slider__slider a');

    for (let i = 0; i < GALLERY_IMAGES.length; i++) {
      const element = GALLERY_IMAGES[i];

      element.addEventListener('click', () => {
        const LIGHTBOX_ELEM = document.querySelector('.slbElement');

        if (LIGHTBOX_ELEM) {
          if (this.sliding) {
            LIGHTBOX_ELEM.classList.add('hidden');
            this.lightBox.close();
          } else {
            LIGHTBOX_ELEM.classList.remove('hidden');
          }
        }
      });
    }
  }
}